var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',[_vm._v("Редактирование сообщения: \""+_vm._s(_vm.mail.title)+"\"")]),_c('div',[_c('mail-form',{attrs:{"mail":_vm.mail},on:{"onSubmit":_vm.submit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }